import { render, staticRenderFns } from "./CustomerTableConfig.vue?vue&type=template&id=208e89d4&scoped=true&lang=pug&"
import script from "./CustomerTableConfig.vue?vue&type=script&lang=js&"
export * from "./CustomerTableConfig.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTableConfig.vue?vue&type=style&index=0&id=208e89d4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208e89d4",
  null
  
)

export default component.exports